<!--
 * @Author: your name
 * @Date: 2022-03-30 17:46:52
 * @LastEditTime: 2022-04-06 11:41:32
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \mingyao\src\views\Contact.vue
-->
<template>
    <div class="contact">
        <div class="para but">
            <div class="map"></div>
            <div class="content">
      <div class="tit">联系方式</div>
      <div class="txt"><span class="t">联系地址:</span><span>苏州工业园区凤里街345号2号楼C座</span></div>
      <!-- <div class="txt"><span class="t">联系电话:</span><span>0512 - 68367076</span></div> -->
      <div class="txt"><span class="t">联系人:</span><span>陈明</span></div>
      <div class="txt"><span class="t">联系手机:</span><span>13773138080</span></div>
        <!-- <div class="map">
            <iframe src="http://map.baidu.com/?latlng=31.337672,120.78234&title=江苏明耀工程技术有限公司&content=苏州工业园区凤里街345号2号楼C座&autoOpen=true&l"></iframe>
        </div> -->
        </div>
        </div>
        <Root />
    </div>
</template>

<script>
import Root from "@/components/Root.vue";
    export default {
        name:"Contact",
        components:{
            Root
        }
    }
</script>

<style lang="less" scoped>
.map{
    width:60%;
    height: 45rem;
    // iframe{
    //     width:100%;
    //     height:40rem;
    // }
    float:left;
    background-image: url(../assets/images/map.png);
}
.content{
    width:calc(40% - 2rem);
    margin-left:2rem;
    float:left;
}
.para {
  padding: 1rem 10% 1rem 10%;
  display: inline-block;
  width: 100%;
}
.tit {
  font-size: 1.5rem;
  color: rgb(27, 151, 243);
  border-left: 5px solid rgb(27, 151, 243);
  padding-left: 0.5rem;
  font-weight: bold;
  text-align: left;
  margin-bottom: 0.5rem;
}
.tit{
    margin-top:20%;
}
.txt{
    text-align: left;
    line-height: 3rem;
    font-size: 1.25rem;
    span{
        margin: 0 0.5rem 0 0.5rem;
    }
}
.t{
    display: inline-block;
    width:6rem;
}
.but{
    margin-bottom:15rem;
}
</style>